import api from "../api";

export class KpiService {
    static async getTeamReport(teamId: number, startDate: Date, endDate: Date, withDailyDetails: boolean): Promise<any> {
        const startDateStr = startDate.toISOString().split('T')[0];
        const endDateStr = endDate.toISOString().split('T')[0];
        const response = await api.get(`/reports`, { params: { teamId , startDate: startDateStr, endDate: endDateStr, withDailyDetails } });
        return response.data;
    }

    static async getUserReport(userId: number, teamId: number, startDate: Date, endDate: Date): Promise<any> {
        const startDateStr = startDate.toISOString().split('T')[0];
        const endDateStr = endDate.toISOString().split('T')[0];
        const response = await api.get(`/reports/user`, { params: { userId, teamId , startDate: startDateStr, endDate: endDateStr } });
        return response.data;
    }
}
